/**
 * Génère un UUID v4 (RFC 4122), éventuellement préfixé pour la lisibilité métier.
 * Les PK distantes (business-api / licensing-api) sont déjà `uuid` PostgreSQL
 * (`DEFAULT gen_random_uuid()` / Drizzle `defaultRandom()`).
 * Jamais de SERIAL / Math.random pour les identifiants ressources (anti-IDOR C3).
 */
export const UUID_V4_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function uuid(prefix?: string): string {
  const base =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : fallbackUuidV4();
  return prefix ? `${prefix}_${base}` : base;
}

/** True si la chaîne est un UUID v4 nu (sans préfixe métier). */
export function isUuidV4(value: string): boolean {
  return UUID_V4_RE.test(value);
}

/** Repli UUID v4 via getRandomValues (jamais Math.random). */
function fallbackUuidV4(): string {
  const bytes = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes);
  } else {
    throw new Error('crypto_unavailable_for_uuid');
  }
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
